var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 24C0.5 37.2548 11.2452 48 24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24Z",
    fill: "#1DA1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 18.8335C31.9 19.1335 31.3 19.2335 30.6 19.3335C31.3 18.9335 31.8 18.3335 32 17.5335C31.4 17.9335 30.7 18.1335 29.9 18.3335C29.3 17.7335 28.4 17.3335 27.5 17.3335C25.4 17.3335 23.8 19.3335 24.3 21.3335C21.6 21.2335 19.2 19.9335 17.5 17.9335C16.6 19.4335 17.1 21.3335 18.5 22.3335C18 22.3335 17.5 22.1335 17 21.9335C17 23.4335 18.1 24.8335 19.6 25.2335C19.1 25.3335 18.6 25.4335 18.1 25.3335C18.5 26.6335 19.7 27.6335 21.2 27.6335C20 28.5335 18.2 29.0335 16.5 28.8335C18 29.7335 19.7 30.3335 21.5 30.3335C27.6 30.3335 31 25.2335 30.8 20.5335C31.5 20.1335 32.1 19.5335 32.5 18.8335Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.54837a7cb68e04a72b0bee28ae992bae.svg";
export { ForwardRef as ReactComponent };